import { render, staticRenderFns } from "./CoventryCity.vue?vue&type=template&id=6a62da72&scoped=true&"
import script from "./CoventryCity.vue?vue&type=script&lang=js&"
export * from "./CoventryCity.vue?vue&type=script&lang=js&"
import style0 from "./CoventryCity.vue?vue&type=style&index=0&id=6a62da72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a62da72",
  null
  
)

export default component.exports